import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import type { Notification } from 'ah-api-gateways';
/**
 * File Export Card component
 *
 * Displays a file export notification.
 *
 * TODO: designs for notifications will likely become like this one. This may replace the existing NotificationCard then
 *
 */


export default /*#__PURE__*/_defineComponent({
  __name: 'FileExportCard',
  props: {
    notification: null,
    openResourceText: { default: 'Open resource' },
    showOpenResource: { type: [Boolean, String], default: false },
    loading: { type: [Boolean, String], default: false }
  },
  emits: ["mark-as-read", "open-resource"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'mark-as-read', notification: Notification): void;
  (e: 'open-resource', notification: Notification): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { notification: Notification, openResourceText: string, showOpenResource: boolean | string, loading: boolean | string };





function markAsRead() {
  emit('mark-as-read', props.notification);
}

function openResource() {
  emit('open-resource', props.notification);
}

const isOpenResourceShown = computed(() => props.showOpenResource !== false);

return { __sfc: true,props, emit, markAsRead, openResource, isOpenResourceShown }
}

})